import { render, staticRenderFns } from "./SnsReviewBlocks.vue?vue&type=template&id=81b9e89a"
import script from "./SnsReviewBlocks.vue?vue&type=script&lang=js"
export * from "./SnsReviewBlocks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports